import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Button,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MatxLoading } from "app/components";
import { fetchInvoice } from "app/services/invoiceServices/Invoice";
import { FormatToBRLCurrency } from "app/data/numberFormater";
import { formatDate } from "app/services/dateTimeServices/format";

const InvoicePrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const contentRef = useRef<HTMLDivElement>(null);

  const [isLoading, setIsLoading] = useState(true);
  const [invoice, setInvoice] = useState<any>(null);

  const getInvoiceInfo = async () => {
    if (!id) return;

    const data = await fetchInvoice(id);
    setInvoice(data.data.response[0]);
    setIsLoading(false);
  };

  useEffect(() => {
    getInvoiceInfo();
  }, []); // eslint-disable-line

  const handlePrint = () => {
    if (!contentRef.current) return;

    const printContents = contentRef.current.innerHTML;
    const printWindow = window.open("", "_blank");

    printWindow?.document.open();
    printWindow?.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Imprimir Fatura</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          table, th, td {
            border: 1px solid black;
          }
          th, td {
            padding: 8px;
            text-align: left;
          }
          .MuiDivider-root {
            margin: 20px 0;
          }
          .header-id {
            text-align: right;
            font-size: 2rem;
            font-weight: bold;
            margin-bottom: 16px;
          }
          @media print {
            .signature-container {
              display: flex;
              justify-content: space-between;
              margin-top: 40px;
            }
            .signature-item {
              width: 45%;
              text-align: center;
            }
          }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
      </html>
    `);

    printWindow?.document.close();
    printWindow?.print();
  };

  if (isLoading) {
    return <MatxLoading />;
  }

  return (
    <>
      {/* Botões */}
      <Box display="flex" justifyContent="center" mt={3} mb={2}>
        <Button variant="contained" onClick={() => navigate("/finance/invoice/list")}>
          Voltar
        </Button>
        &nbsp;
        <Button variant="contained" color="primary" onClick={handlePrint}>
          Imprimir
        </Button>
      </Box>

      {/* Conteúdo imprimível */}
      <Box padding={4} ref={contentRef}>
        <Box className="header-id">
          <Typography variant="h4" fontWeight="bold">
            FATURA #{invoice.id}
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              <strong>Usuário:</strong> {invoice.user.name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              <strong>Status:</strong> {invoice.invoice_status.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Data:</strong> {formatDate(invoice.created_at)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Nota FAI:</strong> {invoice.fai}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          Ordens de Serviço
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Descrição</strong></TableCell>
                <TableCell><strong>Data</strong></TableCell>
                <TableCell align="right">
                  <strong>Valor (R$)</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoice.service_orders.map((os) => (
                <TableRow key={os.id}>
                  <TableCell>{os.service_description}</TableCell>
                  <TableCell>{formatDate(os.created_at)}</TableCell>
                  <TableCell align="right">
                    {FormatToBRLCurrency(Number(os.total_service))}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Divider sx={{ my: 3 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Desconto:</strong>{" "}
              {FormatToBRLCurrency(Number(invoice.discount))}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography fontWeight="bold">
              <strong>Total:</strong>{" "}
              {FormatToBRLCurrency(Number(invoice.total_value))}
            </Typography>
          </Grid>
        </Grid>

        <Box className="signature-container">
          <Box className="signature-item">
            <Divider />
            <Typography mt={2}>Assinatura do Cliente</Typography>
          </Box>
          <Box className="signature-item">
            <Divider />
            <Typography mt={2}>Assinatura do Responsável</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InvoicePrint;
